import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiCPaginatorModule } from '@wlp/ui-c-paginator';
import { SplitFranchisorRoutingModule } from './split-franchisor-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { BrMaskerModule } from 'br-mask';
import { UiCCardInfoModule } from '@wlp/ui-c-card-info';
import { UiCInfoCardModule } from '@wlp/ui-c-info-card';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCNotificationsModule } from '@wlp/ui-c-notifications';
import { UiCDatePickerModule } from '@wlp/ui-c-date-picker';
import { UiCModalModule } from '@wlp/ui-c-modal';
import { HeaderUserInfoModule } from '@wlp/ui-c-header-user-info';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { UiCButtonModule } from "@wlp/ui-c-button";
import { UiCInputModule } from "@wlp/ui-c-input";
import { UiBsSplitModule } from '@wlp/ui-bs-split';
import { SplitManagementPage } from './split-managment/split-management.page';
import { SplitDetailsPage } from './split-details/split-details.page';
import { ComponentsModule } from 'src/app/core/shared/modules/components.module';
import { environment } from 'src/environments/environment';
import { InterceptService } from 'src/app/core/intercept/intercept.service';

@NgModule({
  declarations: [
    SplitManagementPage,
    SplitDetailsPage
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    ReactiveFormsModule,
    NgxMaskIonicModule.forRoot(),
    BrMaskerModule,
    UiCCardInfoModule,
    UiCInfoCardModule,
    UiBsTranslateModule,
    UiCNotificationsModule,
    UiCDatePickerModule.forRoot({ environment: 'web' }),
    UiCModalModule,
    HeaderUserInfoModule,
    SplitFranchisorRoutingModule,
    UiCButtonModule,
    UiCInputModule,
    UiBsSplitModule,
    UiCPaginatorModule.forRoot({ device: 'WEB', config: environment }), // Paginator,
  ],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ],
})
export class SplitFranchisorModule {
}
